/**
 * ProcessRecordStatus - Status for business process records that create blockchain transactions
 *
 * Used for tracking the lifecycle of business operations (campaigns, redemptions) that
 * trigger blockchain transactions. This is distinct from TransactionStatus which tracks
 * the blockchain transaction itself.
 *
 * Usage:
 * - Campaign Claims (user claims rewards via blockchain transactions)
 * - Redemption Redeems (user redeems items via blockchain transactions)
 * - Any business process creating blockchain transactions that need status tracking
 *
 * NOT for blockchain transactions themselves - use TransactionStatus instead.
 */
export var ProcessRecordStatus;
(function (ProcessRecordStatus) {
    ProcessRecordStatus["PENDING"] = "PENDING";
    ProcessRecordStatus["PROCESSING"] = "PROCESSING";
    ProcessRecordStatus["COMPLETED"] = "COMPLETED";
    ProcessRecordStatus["FAILED"] = "FAILED"; // Transaction processing failed (blockchain or validation error)
})(ProcessRecordStatus || (ProcessRecordStatus = {}));
//# sourceMappingURL=process-record-status.enum.js.map